// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2NVcL","buttons":"PendingPaymentAlert_buttons__3Y3qY"};